var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4627 12.8931H2.89322C2.40011 12.8931 2.00037 12.4933 2.00037 12.0002C2.00037 11.5071 2.40011 11.1073 2.89322 11.1073H19.4632C18.1934 9.43614 16.3259 7.88452 14.4692 7.02731C14.0215 6.82061 13.8261 6.29011 14.0328 5.84241C14.2395 5.39472 14.77 5.19935 15.2177 5.40605C17.8889 6.63928 20.5427 9.08342 21.8919 11.5748C22.0354 11.84 22.0354 12.1598 21.8919 12.4251C20.5427 14.9166 17.8889 17.3608 15.2177 18.594C14.77 18.8007 14.2395 18.6054 14.0328 18.1577C13.8261 17.71 14.0215 17.1794 14.4692 16.9727C16.3257 16.1156 18.1932 14.5642 19.4627 12.8931Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineArrowRight);
export default __webpack_public_path__ + "static/media/Line-Arrow-Right.da2e1a24.svg";
export { ForwardRef as ReactComponent };